const BaseURL = process.env.REACT_APP_API_URL;
const GuestURL = BaseURL + '/api/';

export const api = {
    SiteURL: BaseURL,
    news: GuestURL + "news",
}